<template>
  <div class="douyin-login-page">
    <el-card v-if="!isLoggedIn" class="login-card">
      <div slot="header" class="card-header">
        <span>抖音扫码登录</span>
      </div>

      <p class="login-tip">登录后后端会缓存抖音 Cookie，用于后续连接抖音弹幕。</p>
      <el-button type="primary" :loading="qrLoading" @click="handleLogin">
        登录
      </el-button>

      <el-dialog
        title="抖音登录"
        :visible.sync="showQRCode"
        width="480px"
        @close="handleCloseQRCodeDialog"
      >
        <div v-if="loginMode === 'browser_cookie'" class="browser-cookie-wrap">
          <p class="login-status">{{ qrStatusText }}</p>

          <el-button
            type="primary"
            :disabled="!loginUrl"
            @click="openDouyinLogin"
          >
            打开抖音登录页
          </el-button>

          <el-input
            v-model="douyinCookie"
            type="textarea"
            :rows="6"
            class="cookie-input"
            placeholder="登录 douyin.com 后，将完整 Cookie 粘贴到这里"
          />

          <div class="dialog-actions">
            <el-button @click="checkBrowserCookieStatus">
              检查状态
            </el-button>
            <el-button
              type="primary"
              :loading="saveCookieLoading"
              :disabled="!douyinCookie"
              @click="saveDouyinCookie"
            >
              保存 Cookie
            </el-button>
          </div>
        </div>

        <div v-else class="qr-wrap">
          <p class="login-status">{{ qrStatusText }}</p>

          <div class="qr-box">
            <img
              v-if="qrCodeUrl"
              :src="qrCodeUrl"
              alt="抖音登录二维码"
              class="qr-image"
            >
            <i v-else class="el-icon-loading qr-loading-icon"></i>
          </div>

          <el-button
            v-if="qrExpired"
            type="primary"
            :loading="qrLoading"
            class="regen-button"
            @click="handleRegenQRCode"
          >
            重新生成二维码
          </el-button>
        </div>
      </el-dialog>
    </el-card>

    <el-card v-if="isLoggedIn" class="login-card">
      <div slot="header" class="card-header">
        <span>抖音已登录</span>
      </div>

      <h3>欢迎，{{ userName || '抖音用户' }}</h3>
      <el-button type="danger" :loading="logoutLoading" @click="handleLogout">
        注销
      </el-button>
    </el-card>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'TestThree',
  data() {
    return {
      isLoggedIn: false,
      userName: '',
      showQRCode: false,
      qrCodeUrl: '',
      qrcodeKey: '',
      loginUrl: '',
      loginMode: '',
      douyinCookie: '',
      qrPollingInterval: null,
      qrExpired: false,
      qrLoading: false,
      saveCookieLoading: false,
      logoutLoading: false,
      qrStatusText: '请使用抖音 App 扫描二维码登录'
    };
  },
  mounted() {
    this.checkLoginStatus();
  },
  beforeDestroy() {
    this.stopQRCodePolling();
  },
  methods: {
    handleLogin() {
      this.showQRCode = true;
      this.fetchQRCode();
    },

    fetchQRCode() {
      this.stopQRCodePolling();
      this.qrLoading = true;
      this.qrExpired = false;
      this.qrCodeUrl = '';
      this.qrcodeKey = '';
      this.loginUrl = '';
      this.loginMode = '';
      this.douyinCookie = '';
      this.qrStatusText = '正在获取抖音登录地址...';

      axios.get('/api/QRCode/GenerateDouyinQRCode')
        .then(response => {
          const data = response.data || {};
          this.qrCodeUrl = data.qrcodeUrl;
          this.qrcodeKey = data.qrcodeKey;
          this.loginUrl = data.loginUrl || data.qrcodeUrl;
          this.loginMode = data.mode || '';

          if (this.loginMode === 'browser_cookie') {
            this.qrStatusText = '请在浏览器中登录抖音，然后粘贴 douyin.com 的完整 Cookie';
            this.openDouyinLogin();
            return;
          }

          this.qrStatusText = '请使用抖音 App 扫描二维码登录';
          this.startQRCodePolling();
        })
        .catch(error => {
          this.qrStatusText = '获取抖音登录地址失败，请稍后重试';
          console.error('Error fetching Douyin QR code:', error);
        })
        .finally(() => {
          this.qrLoading = false;
        });
    },

    startQRCodePolling() {
      if (!this.qrcodeKey) {
        return;
      }

      this.stopQRCodePolling();
      this.qrPollingInterval = setInterval(() => {
        axios.get('/api/QRCode/CheckDouyinQRCodeStatus', {
          params: { key: this.qrcodeKey }
        })
          .then(response => {
            this.handleQRCodeStatus(response.data);
          })
          .catch(error => {
            this.stopQRCodePolling();
            this.qrStatusText = '扫码状态检查失败，请重新生成二维码';
            console.error('Error checking Douyin QR code status:', error);
          });
      }, 2000);
    },

    handleQRCodeStatus(status) {
      if (status === 1) {
        this.qrStatusText = this.loginMode === 'browser_cookie'
          ? '还没有保存抖音 Cookie'
          : '请使用抖音 App 扫描二维码登录';
      } else if (status === 2) {
        this.qrStatusText = '已扫码，请在手机上确认登录';
      } else if (status === 3) {
        this.stopQRCodePolling();
        this.handleScanLogin();
      } else if (status === 5) {
        this.stopQRCodePolling();
        this.qrExpired = true;
        this.qrStatusText = '二维码已过期，请重新生成';
      } else {
        this.stopQRCodePolling();
        this.qrExpired = true;
        this.qrStatusText = '登录失败或解析异常，请重新生成二维码';
      }
    },

    openDouyinLogin() {
      if (!this.loginUrl) {
        return;
      }

      window.open(this.loginUrl, '_blank');
    },

    saveDouyinCookie() {
      if (!this.douyinCookie) {
        this.$message.warning('请先粘贴 douyin.com 的完整 Cookie');
        return;
      }

      this.saveCookieLoading = true;
      axios.post('/api/QRCode/DouyinSetCookie', {
        cookie: this.douyinCookie
      })
        .then(() => {
          this.$message.success('抖音 Cookie 已保存');
          return this.checkBrowserCookieStatus();
        })
        .catch(error => {
          this.qrStatusText = '保存 Cookie 失败，请确认 Cookie 内容完整';
          console.error('Error setting Douyin cookie:', error);
        })
        .finally(() => {
          this.saveCookieLoading = false;
        });
    },

    checkBrowserCookieStatus() {
      return axios.get('/api/QRCode/CheckDouyinQRCodeStatus', {
        params: { key: 'browser_cookie' }
      })
        .then(response => {
          this.handleQRCodeStatus(response.data);
        })
        .catch(error => {
          this.qrStatusText = '登录状态检查失败';
          console.error('Error checking Douyin browser cookie status:', error);
        });
    },

    handleScanLogin() {
      axios.get('/api/QRCode/DouyinUserName')
        .then(response => {
          this.userName = response.data || '';
          this.isLoggedIn = true;
          this.showQRCode = false;

          localStorage.setItem('douyinLoggedIn', 'true');
          localStorage.setItem('douyinUserName', this.userName);
        })
        .catch(error => {
          console.error('Error getting Douyin user name:', error);
          this.isLoggedIn = true;
          this.showQRCode = false;
        });
    },

    handleLogout() {
      this.logoutLoading = true;
      axios.get('/api/QRCode/DouyinLogOut')
        .then(() => {
          this.isLoggedIn = false;
          this.userName = '';
          localStorage.removeItem('douyinLoggedIn');
          localStorage.removeItem('douyinUserName');
        })
        .catch(error => {
          console.error('Error during Douyin logout:', error);
        })
        .finally(() => {
          this.logoutLoading = false;
        });
    },

    handleCloseQRCodeDialog() {
      this.stopQRCodePolling();
    },

    handleRegenQRCode() {
      this.fetchQRCode();
    },

    checkLoginStatus() {
      axios.get('/api/QRCode/DouyinLogined')
        .then(response => {
          if (response.data) {
            this.isLoggedIn = true;
            this.userName = localStorage.getItem('douyinUserName') || '';
            this.fetchUserName();
          } else {
            this.isLoggedIn = false;
            this.userName = '';
          }
        })
        .catch(error => {
          console.error('Error checking Douyin login status:', error);
        });
    },

    fetchUserName() {
      axios.get('/api/QRCode/DouyinUserName')
        .then(response => {
          this.userName = response.data || this.userName;
          localStorage.setItem('douyinUserName', this.userName);
        })
        .catch(error => {
          console.error('Error getting Douyin user name:', error);
        });
    },

    stopQRCodePolling() {
      if (this.qrPollingInterval) {
        clearInterval(this.qrPollingInterval);
        this.qrPollingInterval = null;
      }
    }
  }
};
</script>

<style scoped>
.douyin-login-page {
  width: 360px;
  margin: 100px auto;
  text-align: center;
}

.login-card {
  width: 100%;
}

.card-header {
  font-weight: 600;
}

.login-tip {
  color: #606266;
  line-height: 24px;
  margin: 0 0 20px;
}

.qr-wrap {
  text-align: center;
}

.browser-cookie-wrap {
  text-align: center;
}

.login-status {
  color: #606266;
  line-height: 24px;
  margin: 0 0 16px;
}

.qr-box {
  width: 240px;
  height: 240px;
  border: 1px solid #ebeef5;
  border-radius: 4px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fff;
}

.qr-image {
  width: 220px;
  height: 220px;
  object-fit: contain;
}

.qr-loading-icon {
  font-size: 28px;
  color: #909399;
}

.regen-button {
  margin-top: 16px;
}

.cookie-input {
  margin-top: 16px;
  text-align: left;
}

.dialog-actions {
  display: flex;
  justify-content: center;
  gap: 12px;
  margin-top: 16px;
}
</style>
